import React, { useRef, useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import cl from "classnames";
import classes from "../filterBar.module.scss";
import Badge from "./Badge";
import Content from "./Content";
import { FilterContext } from "../context";

const FilterOption = ({
  label,
  title,
  reset,
  apply,
  children,
  value,
  error,
  ga,
  hideClearFiltersCta,
}) => {
  const buttonRef = useRef(null);
  const { activeFilter, setActiveFilter } = useContext(FilterContext);
  // const isActive = activeFilter === label
  const [isActive, setIsActive] = useState(activeFilter === label);
  useEffect(() => {
    // console.log(activeFilter)
    setIsActive(activeFilter === label);
  }, [activeFilter]);
  return (
    <div
      className={cl(classes.FilterOption, {
        [classes["FilterOption--focused"]]: isActive,
        [classes["FilterOption--error"]]: !!error,
      })}
      aria-pressed={isActive}
      ref={buttonRef}
    >
      <button
        type="button"
        data-testid={`${label} ${value || ""}`}
        onClick={() => {
          if (isActive) {
            setActiveFilter(null);
          } else {
            setActiveFilter(label);
          }
        }}
        data-ga={ga && `srp-filter-${ga}`}
      >
        {label}
        {!!value && <Badge value={value} />}
      </button>

      <Content
        isActive={isActive}
        close={() => {
          setActiveFilter(null);
        }}
        buttonRef={buttonRef}
        title={title}
        children={children}
        error={error}
        apply={apply}
        reset={reset}
        hideClearFiltersCta={hideClearFiltersCta}
      />
    </div>
  );
};

FilterOption.propTypes = {
  label: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  reset: PropTypes.func,
  apply: PropTypes.func,
  children: PropTypes.node.isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  ga: PropTypes.string,
};

export default FilterOption;
